// ─── Styles de FORMULAIRE partagés (Core) ─────────────────────────
// Base commune des feuilles / formulaires (libellé, champ texte, champ-bouton,
// rangée de puces) — à SPREADER dans le StyleSheet du composant :
//   const makeStyles = (UI) => StyleSheet.create({ ...stylesForm(UI), ...propres });
// Une seule source pour l'apparence des champs → plus de copies divergentes.
export const stylesForm = (UI) => ({
  lbl: { fontSize: 12.5, fontWeight: '700', color: UI.muted, marginTop: 12, marginBottom: 6 },
  input: { backgroundColor: UI.card, borderWidth: 1, borderColor: UI.champBord, borderRadius: 11, paddingHorizontal: 12, paddingVertical: 9, fontSize: 14.5, color: UI.ink },
  champBtn: { backgroundColor: UI.card, borderWidth: 1, borderColor: UI.champBord, borderRadius: 11, paddingHorizontal: 12, paddingVertical: 10 },
  champVal: { fontSize: 14, color: UI.ink },
  champVide: { color: UI.faint },
  puces: { flexDirection: 'row', flexWrap: 'wrap', gap: 8 },
});
